import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Section = styled.section``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 24px;
  }
`;

export const Title = styled(Typography.Header)`
  margin: 0;
`;

export const AddCardLink = styled(Button).attrs({
  appearance: 'secondaryText',
  hasPadding: false,
  isAutoWidth: true,
  size: 's',
})`
  flex-shrink: 0;
  height: auto;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 0 15px;
`;

export const EmptyTitle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: center;
  margin: 15px 0;
`;
